export const formatMesAnyo = (mesAyno) => {
  if (!mesAyno) return "";

  // aca coloco el guion
  const parts = mesAyno.split("-");

  let mes = "";
  let anio = "";

  if (parts.length === 2) {
    // formato MM-YYYY
    [mes, anio] = parts;
  } else if (parts.length === 3) {
    // formato DD-MM-YYYY
    mes = parts[1];
    anio = parts[2];
  } else {
    return mesAyno; 
  }

  const meses = {
    "01": "Ene", "02": "Feb", "03": "Mar", "04": "Abr",
    "05": "May", "06": "Jun", "07": "Jul", "08": "Ago",
    "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dic"
  };

  return `${meses[mes]}-${anio}`;
};
